(() => {
  const initBundleItemCarousels = (root = document) => {
    root.querySelectorAll('scroll-carousel.bundle-card__items[autoplay]:not([data-autoplay-ready])').forEach((carousel) => {
      if (carousel.cells.length <= 1) {
        return;
      }

      const startAutoplay = () => {
        if (!carousel.isScrollable) {
          return;
        }

        if (carousel.hasAttribute('data-autoplay-ready')) {
          return;
        }

        carousel.setAttribute('data-autoplay-ready', 'true');

        const speed = (parseFloat(carousel.getAttribute('autoplay')) || 4) * 1000;
        let paused = carousel.matches(':hover');
        let timer;

        const tick = () => {
          if (paused) {
            return;
          }

          if (carousel.selectedIndex >= carousel.cells.length - 1) {
            carousel.select(0);
          } else {
            carousel.next();
          }
        };

        const restart = () => {
          clearInterval(timer);
          timer = setInterval(tick, speed);
        };

        restart();

        if (carousel.hasAttribute('pause-on-hover')) {
          carousel.addEventListener('mouseenter', () => {
            paused = true;
          });
          carousel.addEventListener('mouseleave', () => {
            paused = false;
          });
          carousel.addEventListener('focusin', () => {
            paused = true;
          });
          carousel.addEventListener('focusout', () => {
            paused = false;
          });
        }

        carousel.addEventListener('carousel:change', restart);
      };

      startAutoplay();

      if (!carousel.isScrollable) {
        window.addEventListener('load', startAutoplay, { once: true });
        new ResizeObserver(startAutoplay).observe(carousel);
      }
    });
  };

  document.addEventListener('DOMContentLoaded', () => initBundleItemCarousels());
  document.addEventListener('shopify:section:load', (event) => initBundleItemCarousels(event.target));
})();
